module.exports = require("stylus");


//////////////////
// WEBPACK FOOTER
// external "stylus"
// module id = 10
// module chunks = 0